<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Cookie from "js-cookie";
export default {
  methods: {
  },
  created(){
     if (process.env.NODE_ENV === "development") {
      Cookie.set("TOKEN", "MlP5qBL7r7acsZi5O2Ii_3Shema5QXNGHey52W2FV68"); // czhTest
    }
  }
}
</script>

<style>
html,body,#app{
	width: 100%;
	height: 100%;
	margin:0;
	padding:0
}

</style>
